export class ApiPaging {
  public page: number;
  public limit: number;
  public itemCount: number;
  public pageCount: number;

  constructor (paging: any) {
    this.page = parseInt(paging.page, 10)
    this.limit = parseInt(paging.limit, 10)
    this.itemCount = parseInt(paging.itemCount, 10)
    this.pageCount = parseInt(paging.pageCount, 10)
  }

  get isFirstPage () {
    return (this.page === 1)
  }

  get isLastPage () {
    return (this.itemCount === 0 || this.page === this.pageCount || this.page > this.pageCount)
  }

  get progress () {
    if (this.pageCount === 0) return 0
    return (this.page / this.pageCount)
  }
}
